import {AuthConfig} from 'angular-oauth2-oidc';

const GOOGLE_CLIENT_ID = '18878801928-nsap66uait3aknl5v2pp1uohj2h07qc1.apps.googleusercontent.com';
const MICROSOFT_CLIENT_ID = '006ef160-3d2e-4892-af97-503d4f16044c';
const MICROSOFT_TENANT_ID = '9188040d-6c67-4c5b-b112-36a304b66dad';

const auth_config_google: AuthConfig = {
	issuer: 'https://accounts.google.com',
	clientId: GOOGLE_CLIENT_ID,
	strictDiscoveryDocumentValidation: false,

	redirectUri: window.location.origin + '/app/assets/popup-callback.html',

	clearHashAfterLogin: false,
	scope: 'openid profile email',
	oidc: true,
}

const auth_config_microsoft: AuthConfig = {
	issuer: `https://login.microsoftonline.com/${MICROSOFT_TENANT_ID}/v2.0`,
// 	issuer: 'https://login.microsoftonline.com/common/v2.0',

	clientId: MICROSOFT_CLIENT_ID,
	strictDiscoveryDocumentValidation: false,
	skipIssuerCheck: true,

// 	loginUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
// 	tokenEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
// 	userinfoEndpoint: 'https://graph.microsoft.com/oidc/userinfo',
// 	logoutUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/logout',

	redirectUri: window.location.origin + '/app/assets/popup-callback.html',

	clearHashAfterLogin: false,
//	disableAtHashCheck: true,
//	showDebugInformation: true,

	scope: 'openid profile email',
	oidc: true,
// 	responseType: 'id_token token',
}

export const auth_providers = [
	{
		name: 'Google',
		icon: 'assets/img/auth/google.svg',
		discoveryUrl: null,
		validateIssuer: null,
		authConfig: auth_config_google,
	},
	{
		name: 'Microsoft',
		icon: 'assets/img/auth/microsoft.svg',
// 		discoveryUrl: 'https://login.microsoftonline.com/common/v2.0/.well-known/openid-configuration',
		discoveryUrl: null,
// 		validateIssuer: 'https://login.microsoftonline.com/{tenantid}/v2.0',
		validateIssuer: null,
		authConfig: auth_config_microsoft,
	}
];
